<template>
  <div class="animated fadeIn">
    <loading v-if="vLoading" />
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-col lg="12" class="ml-auto"></v-col>
    <b-card
      v-if="allowEdit"
      header-bg-variant="primary"
      header-text-variant="white"
      class="item-ckeditor"
    >
      <template v-slot:header>
        <h6>ویرایش قوانین</h6>
      </template>
      <br />
      <ckeditor
        editor="ClassicEditor"
        v-model="editedRules"
      :editor="editor"
                  :config="editorConfig"
      ></ckeditor>
    </b-card>
    <b-btn
      v-if="role == 'Manager'"
      variant="warning"
      class="m-2"
      @click="toggleEdit()"
      >{{ allowEdit ? "ثبت قوانین" : "ویرایش قوانین" }}</b-btn
    >
    <b-card header-bg-variant="primary" header-text-variant="white">
      <template v-slot:header>
        <h6>قوانین صدور استعلام</h6>
      </template>

      <br />
      <span v-html="rules"></span>
      <br />
    </b-card>
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment-jalaali";
import Var from "../../../variables";
import router from "../../router";
import { CKEditor } from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  components: {
    CKEditor,
  },
  data: function () {
    return {
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          "bold",
          "italic",
          "underline",
          "strikethrough",
          "subscript",
          "superscript",
          "fontColor",
        ],
        height: 200,
        language: 'fa',
        contentsLangDirection: 'rtl',
      },
      guide: false,
      rules: "",
      editedRules: "",
      role: "",
      allowEdit: false,
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "|",
            "Subscript",
            "Superscript",
            "TextColor",
            "|",
            "NumberedList",
            "BulletedList",
            "|",
            "Font",
            "FontSize",
          ],
        ],
        height: 200,
      },
    };
  },

  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    getRules() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/office/options/getInfo",
        {
          key: "rules",
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.rules = res.data;
            this.vLoading = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.vLoading = false;
        });
    },
    toggleEdit() {
      this.vLoading = true;
      if (this.allowEdit == false) {
        this.editedRules = this.rules;
        this.allowEdit = true;
        this.vLoading = false;
      } else {
        Axios.post(
          this.baseUrl + "/ppkpms/office/options/edit",
          {
            key: "rules",
            value: this.editedRules,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
          .then((res) => {
            if (res.status == 200) {
              this.toast(res.data, "success");
              this.allowEdit = false;
              this.getRules();
            }
          })
          .catch((err) => {
            this.toast(err.response.data, "error");
          });
      }
    },
  },

  mounted() {
    this.role = localStorage.getItem("role");
    this.getRules();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>

